import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	whatItIs: {
		id: 'software-reports-report-page.header.how-to.what-it-is',
		defaultMessage: 'What it is',
		description: "A heading for a report's help pane",
	},
	howToReadIt: {
		id: 'software-reports-report-page.header.how-to.how-to-read-it',
		defaultMessage: 'How to read it',
		description: "A heading for a report's help pane",
	},
	learnMore: {
		id: 'software-reports-report-page.header.how-to.learn-more',
		defaultMessage: 'Learn more',
		description: "Text for a 'Learn more about this feature' link",
	},

	burnupReportWhat: {
		id: 'software-reports-report-page.header.how-to.burnup-report-what',
		defaultMessage:
			"Maintain your sprint's health by identifying problems such as scope creep or planned path deviation.",
		description: 'Describes what a Burnup Report can do for the customer',
	},
	burnupReportHow: {
		id: 'software-reports-report-page.header.how-to.burnup-report-how',
		defaultMessage:
			'The distance between lines is the amount of work remaining. Examine the Work scope line to identify scope creep. {learnMore}',
		description: 'Describes how to read the Burnup Report',
	},
	velocityReportWhat: {
		id: 'software-reports-report-page.header.how-to.velocity-report-what',
		defaultMessage:
			"Your team's velocity is calculated by taking the average of the total completed estimates from their last few sprints.",
		description: 'Describes what a Velocity Report shows the customer',
	},
	velocityReportHow: {
		id: 'software-reports-report-page.header.how-to.velocity-report-how',
		defaultMessage:
			"Grey: the total estimate of each sprint's issues when the sprint began. Green: the total completed estimates when the sprint ended. {learnMore}",
		description: 'Describes how to read the Velocity Report',
	},
	cumulativeFlowWhat: {
		id: 'software-reports-report-page.header.how-to.cumulative-flow-what',
		defaultMessage:
			'Shows the statuses of issues over time. This helps you identify potential bottlenecks that need to be investigated.',
		description: 'Describes what a Cumulative Flow Diagram shows the customer',
	},
	cumulativeFlowHow: {
		id: 'software-reports-report-page.header.how-to.cumulative-flow-how',
		defaultMessage:
			'The distance between each column lines shows you how long issues take to get from one state to another. Look for points where one band is growing at a faster rate than another to find bottlenecks. {learnMore}',
		description: 'Describes how to read the Cumulative Flow Diagram',
	},
	burndownWhat: {
		id: 'software-reports-report-page.header.how-to.burndown-what',
		defaultMessage:
			'Shows the total work remaining for the current sprint, and the likelihood of your team completing the sprint on time. Also shows a summary of scope changes and work done throughout the sprint.',
		description: 'Describes what a sprint burndown chart shows the customer',
	},
	burndownHow: {
		id: 'software-reports-report-page.header.how-to.burndown-how',
		defaultMessage:
			'The red line shows how much work remains in the sprint. The grey line shows the ideal progress rate. {learnMore}',
		description: 'Describes how to read the  sprint burndown chart',
	},
});
